import get from 'get-value';
import {
  PENDING_GET_TAXAUDITS_ACTION,
  SUCCESS_GET_TAXAUDITS_ACTION,
  SUCCESS_GET_TAX_AUDIT_SCROLL_ACTION,
  FAILURE_GET_TAXAUDITS_ACTION,
  RESET_TAXAUDITS_ACTION
} from '../actionsTypes';
import { initSelection, onToggleSelectAll, onToggleUnSelectAll } from './selection';

const AUDIT_ITEM_NAME: String = 'report';

const initialState = {
  data: [],
  selection: {},
  loading: true,
  error: false,
  errors: {}
};

const taxAuditsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case PENDING_GET_TAXAUDITS_ACTION: {
      return {
        ...state,
        selection: {},
        loading: true,
        error: false,
        errors: {}
      };
    }
    case SUCCESS_GET_TAXAUDITS_ACTION: {
      const {
        payload: { count, scrollId, data }
      } = action;

      const selection = initSelection({ data, key: `${AUDIT_ITEM_NAME}` });

      return {
        ...state,
        data,
        selection,
        count,
        scrollId,
        loading: false,
        error: false,
        errors: {}
      };
    }
    case SUCCESS_GET_TAX_AUDIT_SCROLL_ACTION: {
      const {
        payload: { data: scrollData }
      } = action;
      const data = [...state.data, ...scrollData];
      const selection = {
        ...initSelection({ data, key: `${AUDIT_ITEM_NAME}` }),
        ...state.selection
      };

      return {
        ...state,
        data,
        selection,
        loading: false,
        error: false,
        errors: {}
      };
    }
    case FAILURE_GET_TAXAUDITS_ACTION: {
      const { payload: errors } = action;

      return {
        ...state,
        data: initialState.data,
        selection: {},
        loading: false,
        error: true,
        ...errors
      };
    }
    case RESET_TAXAUDITS_ACTION: {
      return {
        ...state,
        ...initialState
      };
    }
    case 'TOGGLE_SELECT_TAX_AUDITS_ACTION':
    case 'TOGGLE_UNSELECT_TAX_AUDITS_ACTION': {
      const {
        payload: { id }
      } = action;
      const {
        selection: { [id]: value },
        data
      } = state;

      return {
        ...state,
        selection: {
          ...state.selection,
          [id]: !value ? data.find((audit) => get(audit, `${AUDIT_ITEM_NAME}.id`) === id) : false
        }
      };
    }
    case 'TOGGLE_SELECT_ALL_TAX_AUDITS_ACTION': {
      const { selection: prevSelection, data } = state;
      const selection = onToggleSelectAll({
        selection: prevSelection,
        data,
        keyId: `${AUDIT_ITEM_NAME}.id`
      });

      return {
        ...state,
        selection
      };
    }
    case 'TOGGLE_UNSELECT_ALL_TAX_AUDITS_ACTION': {
      const { selection: prevSelection } = state;
      const selection = onToggleUnSelectAll({ selection: prevSelection });

      return {
        ...state,
        selection
      };
    }
    default:
      return state;
  }
};

export default taxAuditsReducer;
